<template>
    <div id="main" class="success_container">
        <div>
          <div class="tip-content stepper-container">
            <div class="circle completed">
              <svg width="16" height="16" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.3754 0.812183C18.4279 -0.265102 20.1405 -0.271531 21.2007 0.797867C22.2609 1.8673 22.2672 3.60756 21.2148 4.68486L8.20668 18L0.795601 10.4957C-0.26258 9.42417 -0.265579 7.68393 0.788909 6.60868C1.8434 5.53343 3.55601 5.53038 4.6142 6.60188L8.1859 10.2185L17.3754 0.812183Z" fill="#0055FF"/>
              </svg>
            </div>
            <div class="stepper-text">{{ $t("barCode.withoutLabelStep1Text") }}</div>
            <div class="stepper-line"></div>
            <div class="circle active">2</div>
            <div class="stepper-text">{{ $t("barCode.withoutLabelStep2Text") }}</div>
          </div>
          <div>
            <div class="success-container">
              <div class="success-png">
                <svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z" fill="#1BB84B"/>
                  <path d="M51.0121 27.3536C52.83 25.5582 55.7882 25.5474 57.6194 27.3298C59.4506 29.1122 59.4616 32.0126 57.6437 33.8081L35.1752 56L22.3742 43.4928C20.5465 41.707 20.5413 38.8066 22.3627 37.0145C24.1841 35.2224 27.1422 35.2173 28.97 37.0031L35.1393 43.0308L51.0121 27.3536Z" fill="white"/>
                </svg>
              </div>
              <div>
                <p>{{ $t("success.withoutLabelStep2SuccessTitle") }}</p>
                <p>{{`${otherNumber}`}}</p>
              </div>
            </div>

            <div class="parcel-logo">
              <svg width="150" height="150" viewBox="0 0 189 190" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.35" d="M94 92.0002L188.5 45.5002L94.5 0.000183105L0.5 45.5002L94 92.0002Z" fill="#00BAFF"/>
              <path opacity="0.2" d="M94 92.0001L0.5 45.5002L0 145L94 189.5V92.0001Z" fill="#00BAFF"/>
              <path opacity="0.5" d="M188.5 144L94 189.5V92.0002L188.5 45.5002V144Z" fill="#00BAFF"/>
              <path d="M106 135V108L173.5 76.5V101.5L106 135Z" fill="white"/>
              </svg>
            </div>
            <div class="success_value">
                <p>{{$t('success.withoutLabelStep2SuccessTitle2')}}</p>
            </div>

          </div>
            <div style="min-height: calc(30vh);"></div>
            <div class="action-button">
                <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
                <button v-if="next" class="details_bt_b" @click="nextAction()">{{$t('success.step1ScanNextWithoutLabel')}}</button>
            </div>

            <bottom></bottom>
        </div>
    </div>
</template>

<script>
import bottom from '../Bottom.vue'

export default {
  name: 'EditRemark',
  data () {
    return {
      showNote: false,
      title: null,
      titleDisplay: null,

      action: null,
      next: false,
      otherNumber: null,
      oldScanResult: null,
      isNeedScanOtherNumber: false
    }
  },
  watch: {
    title (val) {
      if (val === 'MerchantStoreSuccess' || val === 'CustomerStoreSuccess') {
        this.showNote = true
      } else {
        this.showNote = false
      }
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  created () {
    let vue = this
    let param = this.$route.query
    this.title = this.$route.query.msg
    this.action = this.$route.query.action
    this.next = this.$route.query.next !== 'undefined' && this.$route.query.next
    this.original_action = this.$route.query.original_action

    this.otherNumber = this.$route.query.otherNumber
    this.oldScanResult = this.$route.query.oldScanResult
    this.isNeedScanOtherNumber = this.$route.query.isNeedScanOtherNumber
  },
  components: {bottom},
  methods: {
    back () {
      this.$router.go(-1)
    },
    nextAction () {
      // this.$router.push(`/barcode?flow=${flow}&step=1&action=collectingPointStoreExpress&next=true`)
      let vue = this
      console.log('nextAction', this.$route.query, {
        query: {
          flow: 'WITHOUT_LABEL',
          step: '2',
          action: vue.action,
          next: vue.next,
          otherNumber: vue.otherNumber,
          oldScanResult: vue.oldScanResult,
          isNeedScanOtherNumber: vue.isNeedScanOtherNumber
        }
      })
      // return
      vue.$router.push({
        name: 'BarcodeWithoutLabel',
        query: {
          flow: 'WITHOUT_LABEL',
          step: '2',
          action: vue.action,
          next: vue.next,
          otherNumber: vue.otherNumber,
          oldScanResult: vue.oldScanResult,
          isNeedScanOtherNumber: vue.isNeedScanOtherNumber
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .success_png {
        // width: 1.5rem;
        // height: 1.5rem;
        margin: 0 auto;
        margin-top: 11.87%;
        // margin-bottom: 0.5rem;
        margin-bottom: 0.25rem;

        display: flex;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .success_value {
        margin: 0 auto;
        text-align: center;
        min-height: 0.43rem;
        white-space: pre-line;
        font-weight: 900;

        p {
            font-size: 0.3rem;
            color: #000;
            line-height: 0.355rem;
            font-weight: bold;
        }
    }

    .success_id {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      text-decoration: none;
      font-size: 0.15rem;
    }

    .success_text {
        margin: 0 auto;
        width: 2.72rem;
        height: 1.23rem;
        background: #FFFFFF;
        border: 1px solid #707070;
        border-radius: 0.1rem;
        margin-top: 0.415rem;
        padding: 0.135rem 0.185rem;
        text-align: left;
        margin-bottom: 3rem;
        white-space: pre-wrap;

        p {
            font-size: 0.15rem;
            font-weight: 900;
            line-height: 0.18rem;
            color: #ACACAC;
        }
    }

    .details_bt_w {
        width: 82%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        margin: 0.805rem 9% 0;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .details_bt_b {
        width: 82%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: var(--primary-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        // color: #ffffff;
        color: var(--primary-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .scan-note {
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color: #5A5A5A;
        top: 4.4rem;
        left: 1rem;
        width: auto;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #fff;
        box-shadow: -0.03rem 0.06rem 0.09rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.13rem;
        font-size: 0.15rem;
        z-index: 5;
    }

    .scan-icon {
        height: 50%;
    }
    .curtain{
        z-index: 2;
        width:100%;
        height: 100%;
        position:fixed;
        top: 0;
        background: #000;
        opacity:0.5;
        left: 0;
    }
    .remark_details_edit {
        z-index: 3;
        width: 3.415rem;
        height: 3.375rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #ffffff;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }
    .remark_edit_title {
        color: #1F8DC5;
        line-height: 0.18rem;
        height: 0.18rem;
        font-size: 0.15rem;
        margin-left: 4.5%;
        padding-top: 0.245rem;
        font-weight: 500;
    }
    .remark_edit_input {
        height: 2.025rem;
        border: 1px solid rgba(112, 112, 112, 1);
        border-radius: 0.1rem;
        width: 77.5%;
        margin-left: 4.5%;
        margin-top: 0.165rem;
        font: 400 0.15rem Rubik;
        color: #000;
        line-height: 0.18rem;
        padding: 0.12rem 0.17rem;
        display: inline-block;
    }
    .save-cancel-box{
        display: flex;
        flex-direction: row-reverse;
    }
    .remark_edit_a {
        height: 0.18rem;
        font-size: 0.15rem;
        margin-top: 0.1rem;
        display: inline-block;
        font-weight: 400;
        line-height: 0.18rem;
    }

    .remark_edit_a_blue {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        color: #1F8DC5;
    }

    .remark_edit_a_gray {
        color: #ACACAC;
    }
    .remark_scan-note{
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color:#5A5A5A;
        top: 2.4rem;
        left: 50%;
        transform: translate(-50%, 0%);
        /* left: 0.7rem; */
        /* width: auto; */
        width: max-content;
        height:0.3rem;
        line-height: 0.3rem;
        background:#fff;
        box-shadow:-0.03rem 0.06rem 0.09rem rgba(0,0,0,0.16);
        opacity:1;
        border-radius:0.13rem;
        font-size: 0.15rem;
    }
    .remark_scan-icon{
        height: 50%;
    }
    .action-button{
        // position: fixed;
        position: sticky;
        bottom: 0.4rem;
        width: 100%;
    }
    .bottom{
        position: fixed;
        bottom: 0;
    }
    .success_container{
      height: 100vh;
      height: 100svh;
      height: 100dvh;
    }

    .tip-content {
      padding: 0.71rem 0.1rem 0 0.13rem;
      width: 92%;
      height: 0.28rem;
      font-size: 0.2rem;
      font-weight: 100;
      line-height: 0.24rem;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
      text-align: center;
      font-family: "Poppins-Regular";
      margin-top: 20px;
      white-space: pre-line;
    }
    .stepper-container {
      display: flex;
      align-items: center; 
      justify-content: center;
    }
    .stepper-text {
      font-size: 0.12rem;
      color: #666666;
      padding-left: 5px;
    }
    .stepper-line {
      min-width: 36px;
      height: 0.01rem;
      margin: 0 5px;
      background-color: #E6E6E6;
    }
    .circle {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background-color: #E6E6E6;
        display: flex;
        align-items: center; 
        justify-content: center;
        color: #666666;
        font-size: 0.12rem;
        font-weight: bold;
        font-family: Arial, sans-serif;
    }
    .circle.active {
      background-color: #0055FF;
      color: white;
    }
    .circle.completed {
      background-color: #D1E3FF;
      color: white;
    }
    .success-container {
      height: 80px;
      display: flex;
      align-items: center; 
      justify-content: center;
      gap: 20px;
      color: #000000;
      weight: 700;
      font-size: 0.2rem;
      line-height: 0.22rem;
      margin-top: 80px;
      margin-bottom: 80px;
    }
    .parcel-logo{
      display: flex;
      align-items: center; 
      justify-content: center;
      margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Return/Step1SuccessWithoutLabel.vue